import { createSlice } from "@reduxjs/toolkit";
import { subDays } from "date-fns";

const startDate = new Date(subDays(new Date(), 30)).toISOString().split("T")[0];
const endDate = new Date(new Date()).toISOString().split("T")[0];

const initialState = {
  currentPage: 1,
  sortBy: "",
  sortOrder: "",
  search: "",
  date: [startDate, endDate],
  editModal: false,
  currentFilter: "all",
  currentPageSize: 10,
  clear: false,
  showAddModal: false,
  showDeleteModal: false,
};

const certificateUpdateSlice = createSlice({
  name: "certificateUpdate",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
    resetConfig: () => initialState,
  },
});

export const { updateConfig, resetConfig } = certificateUpdateSlice.actions;

export default certificateUpdateSlice.reducer;
